export default (time) => {
    return (x) => (new Promise(resolve => setTimeout(() => resolve(x), time)));
};
